import React from 'react'
import getEnv from '../lib/get-env.js'

function SignOutCallback() {
  const returnUrl =
    localStorage.getItem('returnUrl') || getEnv('REACT_APP_DEFAULT_RETURN_URL')

  if (returnUrl) {
    window.location.href = returnUrl
  }

  return <div></div>
}

export default SignOutCallback
